<template>
  <div>
    <form class="has-placeholders">
      <fieldset>
        <legend>{{ name }}</legend>

        <div class="columns quote-info is-variable is-8-widescreen">
          <div class="column is-half padd-bottom-0">
            <label class="input -spacing-static-c">
              <input
                :class="{
                  input__field: true,
                  error: errors.has('firstName')
                }"
                name="firstName"
                type="text"
                placeholder="First Name"
                v-model="form.firstName"
                v-validate="'required'"
                maxlength="63"
              />
              <span class="input__label">First Name</span>
            </label>

            <label class="input -spacing-static-c">
              <input
                :class="{
                  input__field: true,
                  error: errors.has('lastName')
                }"
                name="lastName"
                type="text"
                placeholder="Last Name"
                v-model="form.lastName"
                v-validate="'required'"
                maxlength="63"
              />
              <span class="input__label">Last Name</span>
            </label>

            <label class="input -spacing-static-c">
              <input
                :class="{
                  input__field: true,
                  error: errors.has('streetAddress#1')
                }"
                name="streetAddress#1"
                type="text"
                placeholder="Street Address"
                v-model="form.streetAddressOne"
                v-validate="'required'"
                id="autocomplete"
              />
              <span class="input__label">Street Address</span>
            </label>

            <label class="input -spacing-static-c">
              <input
                :class="{
                  input__field: true,
                  error: errors.has('zipCode')
                }"
                name="zipCode"
                placeholder="ZIP Code"
                maxlength="5"
                @paste="onPaste"
                v-model="form.zipCode"
                v-validate="'required|numeric|length:5'"
                @input="onlyNumbers"
                data-vv-validate-on="input|blur"
              />
              <span class="input__label">ZIP Code</span>
            </label>

            <label class="input -spacing-static-c">
              <input
                :class="{
                  input__field: true,
                  error: errors.has('city')
                }"
                name="city"
                type="text"
                placeholder="City"
                v-model="form.city"
                v-validate="'required'"
              />
              <span class="input__label">City</span>
            </label>

            <div class="select-wrapper -spacing-static-c">
              <label
                for="state"
                :class="{
                  error: errors.has('state')
                }"
                >State</label
              >
              <v-select
                v-model="form.state"
                :searchable="false"
                :options="selectsInfo.states"
                name="state"
                v-validate="'required'"
                :class="{ error: errors.has('state') }"
              ></v-select>
            </div>

            <div class="select-wrapper -spacing-static-c">
              <label
                for="sameGaragingAddress"
                :class="{
                  error: errors.has('sameGaragingAddress')
                }"
                >Is the above address the same as your garaging address?</label
              >
              <v-select
                v-model="form.isGarageSameAsMailing"
                :searchable="false"
                :options="selectsInfo.isGarageSameAsMailing"
                name="sameGaragingAddress"
                v-validate="'required'"
                :class="{ error: errors.has('sameGaragingAddress') }"
                v-on:input="dropdownChanged"
              ></v-select>
            </div>

            <label
              v-if="checkGaragagingAddress"
              class="input -spacing-static-c"
            >
              <input
                :class="{
                  input__field: true,
                  error: errors.has('garagingStreetAddress#1')
                }"
                name="garagingStreetAddress#1"
                type="text"
                placeholder="Garaging Street Address"
                v-model="form.garagingStreetAddressOne"
                v-validate="'required'"
                id="autocomplete-garaging"
              />
              <span class="input__label">Garaging Street Address</span>
            </label>

            <label
              v-if="checkGaragagingAddress"
              class="input -spacing-static-c"
            >
              <input
                :class="{
                  input__field: true,
                  error: errors.has('garagingZipCode')
                }"
                name="garagingZipCode"
                placeholder="Garaging ZIP Code"
                maxlength="5"
                @paste="onPaste"
                v-model="form.garagingZipCode"
                @input="onlyNumbersForGarage"
                v-validate="'required|numeric|length:5'"
                data-vv-validate-on="input|blur"
              />
              <span class="input__label">Garaging ZIP Code</span>
            </label>
            <label
              v-if="checkGaragagingAddress"
              class="input -spacing-static-c"
            >
              <input
                :class="{
                  input__field: true,
                  error: errors.has('garagingCity')
                }"
                name="garagingCity"
                type="text"
                placeholder="Garaging City"
                v-model="form.garagingCity"
                v-validate="'required'"
              />
              <span class="input__label">Garaging City</span>
            </label>

            <div
              v-if="checkGaragagingAddress"
              class="select-wrapper -spacing-static-c"
            >
              <label
                for="Garaging State"
                :class="{
                  error: errors.has('Garaging State')
                }"
                >Garaging State</label
              >
              <v-select
                v-model="form.garagingState"
                :searchable="false"
                :options="selectsInfo.states"
                name="Garaging State"
                v-validate="'required'"
                :class="{ error: errors.has('Garaging State') }"
              ></v-select>
            </div>
          </div>

          <div class="column is-half padd-top-0">
            <div
              v-if="
                form.state &&
                  form.state.value &&
                  (form.state.value === 'AZ' ||
                    form.state.value === 'OH' ||
                    form.state.value === 'PA' ||
                    form.state.value === 'TN' ||
                    form.state.value === 'WI')
              "
              class="select-wrapper -spacing-static-c"
            >
              <label
                for="lengthOfResidency"
                :class="{
                  error: errors.has('lengthOfResidency')
                }"
                >How long have you lived at this address?</label
              >
              <v-select
                v-model="form.lengthOfResidency"
                :searchable="false"
                :options="selectsInfo[form.state.value].lengthOfResidency"
                name="lengthOfResidency"
                id="lengthOfResidency"
                placeholder="How long have you lived at this address?"
                v-validate="'required'"
                :class="{
                  error: errors.has('lengthOfResidency')
                }"
              ></v-select>
            </div>
            <label
              v-if="form.state && form.state.value === 'OH'"
              class="input -spacing-static-c"
            >
              <input
                :class="{
                  input__field: true,
                  error: errors.has('householdCount')
                }"
                name="householdCount"
                type="number"
                placeholder="Number of People in Household"
                v-model="form.householdCount"
                v-validate="'required|numeric'"
              />
              <span class="input__label">Number of People in Household</span>
            </label>
            <div class="limit-container">
              <label class="input -spacing-static-c">
                <masked-input
                  :class="{
                    input__field: true,
                    error: errors.has('dateOfBirth')
                  }"
                  name="dateOfBirth"
                  placeholder="Date of birth (MM/DD/YYYY)"
                  v-model="form.dateOfBirth"
                  :keepCharPositions="true"
                  v-validate="'required|validate18YrsOld|isLeapYear'"
                  :placeholderChar="'_'"
                  @blur="checkWorking('dateOfBirth', form.dateOfBirth)"
                  :pipe="autoCorrectedDatePipe"
                  :mask="[
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/
                  ]"
                  :guide="true"
                ></masked-input>
                <span class="input__label">Date of birth (MM/DD/YYYY)</span>
              </label>
              <span class="icon calendar-icon">
                <vue-fontawesome :icon="['fal', 'calendar']" />
              </span>
              <b-datepicker
                name="dateOfBirth1"
                @input="changedDOB"
                v-model="selectedDate"
                :max-date="validationOptions.atleastEighteenYrsOld"
                :min-date="validationOptions.someOldDate"
                :focused-date="validationOptions.atleastEighteenYrsOld"
                :mobile-native="false"
              ></b-datepicker>
            </div>
            <label class="input -spacing-static-c phone-number-field">
              <cleave
                :class="{
                  input__field: true,
                  error: errors.has('mobilePhoneNumber')
                }"
                name="mobilePhoneNumber"
                :options="validationOptions.phoneNumber"
                placeholder="Mobile Phone Number (000-000-0000)"
                v-model="form.mobilePhoneNumber"
                v-validate="'required|phoneNumber'"
                @blur="setContactNumber"
              ></cleave>
              <span class="input__label"
                >Mobile Phone Number (000-000-0000)</span
              >
              <i class="icon icon--info tool-tip">
                <div class="content">
                  <p>
                    We use your mobile phone number to send you important policy
                    notifications, namely reminders to submit your odometer
                    photo.
                  </p>
                  <i></i>
                </div>
              </i>
            </label>
            <label class="input -spacing-static-c phone-number-field">
              <cleave
                :class="{
                  input__field: true,
                  error: errors.has('preferredContactNumber')
                }"
                name="preferredContactNumber"
                :options="validationOptions.phoneNumber"
                placeholder="Preferred Contact Number (000-000-0000)"
                v-model="form.preferredContactNumber"
                v-validate="'required|phoneNumber'"
              ></cleave>
              <span class="input__label"
                >Preferred Contact Number (000-000-0000)</span
              >
            </label>
            <!-- <div class="select-wrapper -spacing-static-c">
              <label
                for="phoneType"
                :class="{
                  error: errors.has('phoneType')
                }"
                >Phone type</label
              >
              <v-select
                v-model="form.phoneType"
                :searchable="false"
                :options="selectsInfo.phoneType"
                name="phoneType"
                v-validate="'required'"
                :class="{ error: errors.has('phoneType') }"
              ></v-select>
            </div>-->
            <div class="select-wrapper -spacing-static-c">
              <label
                for="hearAbout"
                :class="{
                  error: errors.has('hearAbout')
                }"
                >How did you hear about Porsche Auto Insurance?</label
              >
              <v-select
                v-model="form.hearAbout"
                :searchable="false"
                :options="selectsInfo.hearAbout"
                name="hearAbout"
                v-validate="'required'"
                :class="{ error: errors.has('hearAbout') }"
              ></v-select>
            </div>

            <div
              v-if="checkIfDealerSelected"
              class="select-wrapper -spacing-static-c"
            >
              <label
                for="dealer"
                :class="{
                  error: errors.has('dealer')
                }"
                >Which Dealer?</label
              >
              <v-select
                v-model="form.dealer"
                :searchable="false"
                :options="selectsInfo.dealers"
                name="dealer"
                v-validate="'required'"
                :class="{ error: errors.has('dealer') }"
              ></v-select>
            </div>
            <div class="select-wrapper -spacing-static-c">
              <label
                for="isPCAMember"
                :class="{
                  'pca-member-containter': true,
                  error: errors.has('isPCAMember')
                }"
                >Are you a member of Porsche Club of America?
                <i class="icon icon--info tool-tip">
                  <div class="content">
                    <p>
                      PCA members are eligible for exclusive discounts on
                      Porsche Auto Insurance.
                    </p>
                    <i></i>
                  </div>
                </i>
              </label>
              <v-select
                v-model="form.isPCAMember"
                :searchable="false"
                :options="selectsInfo.PCAMemberOptions"
                name="isPCAMember"
                v-validate="'required'"
                :class="{ error: errors.has('isPCAMember') }"
              ></v-select>
            </div>
          </div>
        </div>
        <div class="button-right-align">
          <button
            @click="$emit('goBack')"
            type="button"
            v-if="currentStepNumber > 1 && currentStepNumber < 5"
            class="button-primary button-primary--black -spacing-static-b"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">Back</span>
          </button>

          <button
            @click="$emit('nextButtonAction')"
            type="button"
            class="button-primary button-primary--black -spacing-static-b your-info-continue-button"
            v-if="currentStepNumber !== 7"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">{{
              isLastStep ? 'Submit' : 'Continue'
            }}</span>
          </button>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { canUseAdvertising, safeGtag } from '@/utils/tracking';
import moment from 'moment';
import * as _ from 'lodash';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { restrictedZips } from '@/components/quote/restrictedZips';
import { setTimeout } from 'timers';

export default {
  props: {
    wizardData: {
      type: Object,
      required: true
    },
    currentStepNumber: {
      type: Number
    },
    isLastStep: {
      type: Boolean
    }
  },
  data: () => ({
    name: 'Your Information',
    form: {
      firstName: null,
      lastName: null,
      streetAddressOne: null,
      zipCode: null,
      city: null,
      state: null,
      lengthOfResidency: null,
      householdCount: null,
      isGarageSameAsMailing: null,
      garagingStreetAddressOne: null,
      garagingZipCode: null,
      garagingCity: null,
      dateOfBirth: '',
      mobilePhoneNumber: null,
      preferredContactNumber: null,
      phoneType: null,
      hearAbout: null,
      dealer: null,
      garagingState: null,
      isPCAMember: null
    },
    validationOptions: {
      phoneNumber: {
        phone: true,
        phoneRegionCode: 'US',
        delimiter: '-'
      },
      dateOfBirth: {
        date: true,
        datePattern: ['m', 'd', 'Y'],
        delimiter: '/'
      },
      atleastEighteenYrsOld: new Date(
        new Date().setFullYear(new Date().getFullYear() - 18)
      ),
      someOldDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 120)
      )
    },
    autocomplete: null,
    autocompleteGaraging: null,
    selectedDate: null
  }),
  beforeMount() {
    if (this.quoteForm.info.state !== null) {
      this.form.state = this.quoteForm.info.state;
    }
  },
  mounted() {
    this.floodlightInfo();
    this.autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('autocomplete'),
      { types: ['geocode'] }
    );
    this.autocomplete.addListener('place_changed', this.autoCompleteOptions);
    if (!_.isEmpty(this.quoteForm.info)) {
      this.form = _.cloneDeep(this.quoteForm.info);
    }
  },
  computed: {
    ...mapGetters(['quoteForm', 'selectsInfo']),
    checkIfDealerSelected() {
      const hearAbout = { ...this.form.hearAbout };
      return hearAbout.value === 'Dealer';
    },
    checkGaragagingAddress() {
      const isGarageSameAsMailing = { ...this.form.isGarageSameAsMailing };
      return isGarageSameAsMailing.value === 2;
    },
    autoCorrectedDatePipe() {
      return createAutoCorrectedDatePipe('mm/dd/yyyy');
    }
  },
  methods: {
    ...mapMutations(['updateForm', 'toggleLoader']),
    floodlightInfo() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      } else if (!canUseAdvertising()) {
        return;
      } else {
        // console.log('2025 Floodlight 1 Active');
        // Porsche PAI Receive a quote Form Continue Button 1.Your Info
        let flDiv = document.body.appendChild(document.createElement('div'));
        let GDPR = '${GDPR}';
        let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
        flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
        flDiv.style.position = 'absolute';
        flDiv.style.top = '0';
        flDiv.style.left = '0';
        flDiv.style.width = '1px';
        flDiv.style.height = '1px';
        flDiv.style.display = 'none';
        flDiv.innerHTML = `
            <img src="https://ad.doubleclick.net/ddm/activity/src=5368208;type=2025p0;cat=porsc00;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>
          `;
        if (process.env.VUE_APP_GOOGLE_ANALYTICS === 'enable') {
          safeGtag('advertising', 'event', 'conversion', {
            allow_custom_scripts: true,
            send_to: 'DC-5368208/2025p0/porsc00+standard'
          });
        }
      }
    },
    onPaste(event) {
      event.clipboardData.getData('text/plain').slice(0, 5);
    },

    onlyNumbers() {
      this.form.zipCode = this.form.zipCode.toString().replace(/[^0-9]/g, '');
      if (this.form.zipCode.length === 5) {
        if (restrictedZips.includes(this.form.zipCode)) {
          this.toggleLoader({
            loaderText: 'One moment while we verify your location...'
          });
          setTimeout(() => {
            this.toggleLoader();
            this.$router.push('/not-available?weather-exception');
          }, 3000);
        }
      }
    },

    onlyNumbersForGarage() {
      this.form.garagingZipCode = this.form.garagingZipCode
        .toString()
        .replace(/[^0-9]/g, '');
      if (this.form.garagingZipCode.length === 5) {
        if (restrictedZips.includes(this.form.garagingZipCode)) {
          this.toggleLoader({
            loaderText: 'One moment while we verify your location...'
          });
          setTimeout(() => {
            this.toggleLoader();
            this.$router.push('/not-available?weather-exception');
          }, 3000);
        }
      }
    },

    checkWorking(key, value) {
      let validator = this.$validator;
      validator.validate(key, value);
    },

    getFormattedDate(dateObject) {
      let momentDateObj = moment(dateObject);
      return momentDateObj.format('MM/DD/YYYY');
    },

    submit() {
      let firstErrorField;

      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (result) {
            let payload = {
              info: _.cloneDeep(this.form)
            };
            this.updateForm(payload);
            resolve(true);
          } else {
            firstErrorField = this.$el.querySelector(
              '[name="' + this.$validator.errors.items[0].field + '"]'
            );
            if (firstErrorField) {
              firstErrorField.focus();
            }

            reject('invalid fields');
          }
        });
      });
    },
    dropdownChanged() {
      if (this.form.isGarageSameAsMailing.value === 2) {
        setTimeout(() => {
          this.autocompleteGaraging = new google.maps.places.Autocomplete(
            document.getElementById('autocomplete-garaging'),
            { types: ['geocode'] }
          );
          this.autocompleteGaraging.addListener(
            'place_changed',
            this.autoCompleteOptionsGaraging
          );
        });
      } else {
        this.autocompleteGaraging = null;
      }
    },
    autoCompleteOptions() {
      var place = this.autocomplete.getPlace();
      this.form.zipCode = null;
      this.form.city = null;
      this.form.state = null;
      this.form.streetAddressOne = '';
      if (
        place &&
        place.address_components &&
        place.address_components.length
      ) {
        for (var i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types[0] === 'street_number') {
            this.form.streetAddressOne +=
              place.address_components[i].short_name;
          }
          if (place.address_components[i].types[0] === 'route') {
            this.form.streetAddressOne +=
              ' ' + place.address_components[i].long_name;
          }
          if (place.address_components[i].types[0] === 'postal_code') {
            if (
              restrictedZips.includes(place.address_components[i].short_name)
            ) {
              this.toggleLoader({
                loaderText: 'One moment while we verify your location...'
              });
              setTimeout(() => {
                this.toggleLoader();
                this.$router.push('/unavailable?weather-exception');
              }, 3000);
            }
            this.form.zipCode = place.address_components[i].short_name;
          }
          if (place.address_components[i].types[0] === 'locality') {
            this.form.city = place.address_components[i].short_name;
          }
          if (
            place.address_components[i].types[0] ===
            'administrative_area_level_1'
          ) {
            // place.address_components[i].short_name === 'CA' ||
            // place.address_components[i].short_name === 'FL' ||
            // place.address_components[i].short_name === 'OR' ||
            // place.address_components[i].short_name === 'PA' ||
            // place.address_components[i].short_name === 'TN' ||
            // place.address_components[i].short_name === 'TX' ||
            // place.address_components[i].short_name === 'WI'
            if (
              place.address_components[i].short_name === 'AZ' ||
              place.address_components[i].short_name === 'CO' ||
              place.address_components[i].short_name === 'FL' ||
              place.address_components[i].short_name === 'GA' ||
              place.address_components[i].short_name === 'IL' ||
              place.address_components[i].short_name === 'OH' ||
              place.address_components[i].short_name === 'OR' ||
              place.address_components[i].short_name === 'TN' ||
              place.address_components[i].short_name === 'TX' ||
              place.address_components[i].short_name === 'UT'
            ) {
              this.form.state = {
                label: place.address_components[i].long_name,
                value: place.address_components[i].short_name
              };
            } else {
              const stateCode = place.address_components[i].short_name;

              this.toggleLoader({
                loaderText: 'One moment while we verify your location...'
              });
              setTimeout(() => {
                this.toggleLoader();
                if (!stateCode) {
                  this.$router.push('/unavailable?not-writing');
                } else {
                  this.$router.push({
                    name: 'Unavailable',
                    query: { state: stateCode }
                  });
                }
              }, 3000);
            }
          }
        }
      }
    },
    autoCompleteOptionsGaraging() {
      var place = this.autocompleteGaraging.getPlace();
      this.form.garagingZipCode = null;
      this.form.garagingCity = null;
      this.form.garagingState = null;
      this.form.garagingStreetAddressOne = '';
      if (
        place &&
        place.address_components &&
        place.address_components.length
      ) {
        for (var i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types[0] === 'street_number') {
            this.form.garagingStreetAddressOne +=
              place.address_components[i].short_name;
          }
          if (place.address_components[i].types[0] === 'route') {
            this.form.garagingStreetAddressOne +=
              ' ' + place.address_components[i].long_name;
          }
          if (place.address_components[i].types[0] === 'postal_code') {
            this.form.garagingZipCode = place.address_components[i].short_name;
          }
          if (place.address_components[i].types[0] === 'locality') {
            this.form.garagingCity = place.address_components[i].short_name;
          }
          if (
            place.address_components[i].types[0] ===
            'administrative_area_level_1'
          ) {
            if (
              place.address_components[i].short_name === 'AZ' ||
              place.address_components[i].short_name === 'CO' ||
              place.address_components[i].short_name === 'FL' ||
              place.address_components[i].short_name === 'GA' ||
              place.address_components[i].short_name === 'IL' ||
              place.address_components[i].short_name === 'OH' ||
              place.address_components[i].short_name === 'OR' ||
              place.address_components[i].short_name === 'TN' ||
              place.address_components[i].short_name === 'TX' ||
              place.address_components[i].short_name === 'UT'
            ) {
              // place.address_components[i].short_name === 'CA' ||
              // place.address_components[i].short_name === 'FL' ||
              // place.address_components[i].short_name === 'IL' ||
              // place.address_components[i].short_name === 'OR' ||
              // place.address_components[i].short_name === 'PA' ||
              // place.address_components[i].short_name === 'TN' ||
              // place.address_components[i].short_name === 'TX' ||
              // place.address_components[i].short_name === 'WI'
              this.form.garagingState = {
                label: place.address_components[i].long_name,
                value: place.address_components[i].short_name
              };
            } else {
              this.toggleLoader({
                loaderText: 'One moment while we verify your location...'
              });
              const stateCode = place.address_components[i].short_name;
              setTimeout(() => {
                this.toggleLoader();
                if (!stateCode) {
                  this.$router.push('/not-available');
                } else {
                  this.$router.push('/not-available?state=' + stateCode);
                }
              }, 3000);
            }
          }
        }
      }
    },
    setContactNumber() {
      let validator = this.$validator;
      validator
        .validate('mobilePhoneNumber', this.form.mobilePhoneNumber)
        .then(result => {
          if (result && this.form.mobilePhoneNumber.length) {
            this.form.preferredContactNumber = this.form.mobilePhoneNumber;
            validator.validate(
              'preferredContactNumber',
              this.form.preferredContactNumber
            );
          }
        });
    },
    changedDOB(event) {
      this.form.dateOfBirth = moment(event).format('MM/DD/YYYY');
      this.selectedDate = null;
      this.$el.querySelector('[name="dateOfBirth"]').focus();
      this.$validator.validate('dateOfBirth', this.form.dateOfBirth);
    }
  }
};
</script>
<style lang="scss">
@import 'src/assets/sass/modules/form/datepicker.scss';
.quote-info .popover-container input.error {
  border-color: $red;
  border-width: 2px;
}
@media (max-width: 760px) {
  .padd-bottom-0 {
    padding-bottom: 0px;
  }
  .padd-top-0 {
    padding-top: 0px;
  }
}

.button-right-align {
  display: flex;
  justify-content: flex-end;
}
</style>
<style scoped lang="scss">
.phone-number-field {
  .input__field {
    @media (max-width: 760px) {
      font-size: 13px;
    }
  }
}
.tool-tip {
  position: absolute;
  color: #737278;
  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 1;
  .content {
    left: -170px;
    @media (max-width: 991px) {
      width: 390px;
      left: -150px;
    }
    @media (max-width: 760px) {
      left: -83px;
      width: 300px;
    }

    @media (min-width: 992px) {
      line-height: 1.5;
      font-size: 1rem;
      padding: 25px 30px;
      width: 425px;
    }
    i {
      @media (min-width: 992px) {
        right: 17px;
        left: auto;
      }
      @media (max-width: 991px) and (min-width: 761px) {
        left: 352px;
      }
      @media (max-width: 760px) {
        left: 80%;
      }
    }
  }
}
.pca-member-containter {
  position: relative;
  .tool-tip {
    right: -20px;
    top: 40%;
    @media (max-width: 855px) and (min-width: 759px) {
      top: 70%;
    }
    @media (max-width: 760px) {
      top: 40%;
    }
    @media (max-width: 398px) {
      top: 70%;
    }
    .content {
      @media (max-width: 398px) {
        width: 250px;
        left: 55px;
        i {
          left: 31%;
        }
      }
      @media (max-width: 760px) and (min-width: 399px) {
        width: 255px;
        i {
          left: 85%;
        }
      }
      @media (min-width: 992px) {
        left: -150px;
        width: 390px;
      }
    }
  }
}
</style>
